﻿// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import Language from './Language.tsx';
import SupportTicket from './SupportTicket.tsx';
import SupportChat from './SupportChat.tsx';
import MobileSection from './MobileSection';


// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {!downLG && <Search />}
      { <Language /> }
      { <SupportTicket /> }
      { /* <SupportChat /> */ }
      { /* <Notification /> */ }
      { <Profile /> }
    </>
  );
}

